import React, { FC, memo } from 'react';
import { useDataTableContext } from '../utils/DataTableContext';
import { Tr } from './Tr';
import { MemoizeTh } from './MemoizeTh';
import { UtilityColumns } from '../hooks/columnHooks';
import styled from 'styled-components';

interface Props {
  calculatedTableHeight: number;
}

export const Thead: FC<React.PropsWithChildren<Props>> = memo(({ children, calculatedTableHeight }) => {
  const { getHeaderGroups, tableHeight, border, resizeTableColumns } = useDataTableContext();
  const headerGroups = getHeaderGroups?.();
  return (
    <StyledThead $isContentHeight={tableHeight === 'content'}>
      {children ||
        headerGroups?.map((headerGroup) => (
          <Tr
            resizeTableColumns={resizeTableColumns}
            isSelected={false}
            isSkeleton={false}
            rowHeight={undefined}
            dataTest="data-table-header"
            key={headerGroup.id}
          >
            {headerGroup.headers.map(({ id, column, getContext, getResizeHandler, getSize }) => (
              <MemoizeTh
                getSize={getSize}
                key={id}
                border={border}
                resizeTableColumns={resizeTableColumns}
                enableSorting={column.columnDef.enableSorting}
                calculatedTableHeight={calculatedTableHeight}
                getResizeHandler={getResizeHandler}
                resetSize={column.resetSize}
                isResizing={column.getIsResizing()}
                canResize={column.getCanResize() && resizeTableColumns && canResize(id)}
                id={id}
                onToggleSorting={column.toggleSorting}
                meta={column.columnDef.meta}
                header={column.columnDef.header}
                sorted={column.getIsSorted()}
                getContext={getContext}
              />
            ))}
          </Tr>
        ))}
    </StyledThead>
  );
});

export const StyledThead = styled.div<{ $isContentHeight: boolean }>`
  position: ${({ $isContentHeight }) => ($isContentHeight ? 'inherit' : 'sticky')};
  top: 0;
  z-index: 10;
`;

const canResize = (columnId: string): boolean =>
  ![UtilityColumns.EXPANDER, UtilityColumns.SELECTION, UtilityColumns.MENU, UtilityColumns.MENU_V2].includes(
    columnId as UtilityColumns
  );
